<template>
  <div class="footer">
    <!-- pc端 -->
    <div class="footer-pc" v-if="!isMobile">
      <div class="footer-nav">
        <div class="footer-nav-content">
          <div class="content-top">
            <div class="content-top-left">
              <img :src="require('@/assets/images/hsk_mock_logo.png')" />
              <div v-html="$t('footer')" class="text"></div>
              <ol class="link-list">
                <li
                  v-for="(item, index) in linkArray"
                  :key="item.id"
                  @click="trackEvent(item.track)"
                >
                  <div v-if="index === 1">
                    <el-popover placement="top" width="200" trigger="click">
                      <img :src="item.url" :alt="item.name" />
                      <img slot="reference" :src="item.image" :alt="item.name" />
                    </el-popover>
                  </div>
                  <a :href="item.url" target="_blank" v-else>
                    <img :src="item.image" :alt="item.name" />
                  </a>
                </li>
              </ol>
            </div>
            <div class="content-top-right">
              <span class="link" @click="handleClick('mock_tests')">{{ $t('mock_tests') }}</span>
              <span class="link" @click="handleClick('blog_and_faq')">{{
                $t('blog_and_faq')
              }}</span>
              <span class="link" @click="handleClick('feedback')">{{ $t('contact') }}</span>
              <span class="link" @click="handleClick('about-us')">{{ $t('about_us_new') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright-wrap">
        <p class="copyright china-text" v-if="isChina">
          版权 © 2023 我会我汇我慧科技(上海)有限公司,All Rights
          Reserved.备案号:沪ICP备2022031870号-1
          &nbsp;&nbsp;&nbsp;增值电信业务经营许可证：牌照沪B2-20230057
        </p>
        <p v-else class="copyright">
          {{ $t('isp') }}
        </p>
      </div>
    </div>
    <!-- 移动端 -->
    <div v-else class="footer-mobile">
      <div class="footer-nav">
        <div class="footer-nav-content">
          <div class="content-top">
            <div class="content-top-left">
              <img :src="require('@/assets/images/hsk_mock_logo.png')" />
              <div v-html="$t('footer')" class="text"></div>
              <ol class="link-list">
                <li
                  v-for="(item, index) in linkArray"
                  :key="item.id"
                  @click="trackEvent(item.track)"
                >
                  <div v-if="index === 1">
                    <el-popover placement="top" width="200" trigger="click">
                      <img :src="item.url" :alt="item.name" />
                      <img slot="reference" :src="item.image" :alt="item.name" />
                    </el-popover>
                  </div>
                  <a :href="item.url" target="_blank" v-else>
                    <img :src="item.image" :alt="item.name" />
                  </a>
                </li>
              </ol>
            </div>
            <div class="content-top-right">
              <span class="link" @click="handleClick('mock_tests')">{{ $t('mock_tests') }}</span>
              <span class="link" @click="handleClick('blog_and_faq')">{{
                $t('blog_and_faq')
              }}</span>
              <span class="link" @click="handleClick('feedback')">{{ $t('contact') }}</span>
              <span class="link" @click="handleClick('about-us')">{{ $t('about_us_new') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright-wrap">
        <p class="copyright china-text" v-if="isChina">
          版权 © 2023 我会我汇我慧科技(上海)有限公司,All Rights
          Reserved.备案号:沪ICP备2022031870号-1
          &nbsp;&nbsp;&nbsp;增值电信业务经营许可证：牌照沪B2-20230057
        </p>
        <p v-else class="copyright">
          {{ $t('isp') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import analytics from '@/utils/AnalyticsCenter'
let Mask_logo_en = require('@/assets/images/Mask_logo_en.png')
let Mask_logo_zh = require('@/assets/images/Mask_logo_zh.png')
import { mixinMixpanel } from '@/mixins'
import { IS_CHINA } from '@/config'
export default {
  name: 'Footer',
  mixins: [mixinMixpanel],
  data() {
    return {
      Mask_logo_en: Mask_logo_en,
      Mask_logo_zh: Mask_logo_zh,
      // 超链集合
      linkArray: [
        // {
        //   image: require('@/assets/images/footer/email.png'),
        //   name: 'email',
        //   url: '//wohuimandarin.us18.list-manage.com/subscribe?u=ebb71ed848680fe5b9e4caa78&id=a4fec2cd25',
        //   track: 'hskweb_email_click',
        // },
        // {
        //   image: require('@/assets/images/footer/wechat_logo.png'),
        //   name: 'wechat',
        //   url: require('@/assets/images/footer/wechat.png'),
        //   track: 'hskweb_wechat_click',
        // },
        {
          image: require('@/assets/images/footer/icon-in.svg'),
          name: 'In',
          url: '//www.instagram.com/WoHuiMandarin/ ',
          track: 'hskweb_in_click',
        },
        {
          image: require('@/assets/images/footer/icon-instagram.svg'),
          name: 'Instagram',
          url: '//www.instagram.com/WoHuiMandarin/ ',
          track: 'hskweb_ins_click',
        },
        {
          image: require('@/assets/images/footer/icon-facebook.svg'),
          name: 'Facebook',
          url: '//www.facebook.com/WoHuiMandarin/',
          track: 'hskweb_facebook_click',
        },
        {
          image: require('@/assets/images/footer/icon-youtube.svg'),
          name: 'Youtube',
          url: '//www.facebook.com/WoHuiMandarin/',
          track: 'hskweb_youtube_click',
        },
      ],
    }
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    language() {
      return localStorage.getItem('language') == 'zh'
    },
    isChina() {
      return IS_CHINA
    },
  },
  // mounted(){
  //   console.log('mockPublicUrl',this.$store.state.publicUrl.mockPublicUrl)
  // },
  methods: {
    handleClick(key) {
      // TODO：关于我们、意见反馈、app下载地址、copyright
      let mixpanelParams = { position: 'bottom' }
      if (key === 'about-us') {
        analytics.logEvent('hskweb_aboutus_click')
        this.$router.push('/about')
      } else if (key === 'mock_tests') {
        analytics.logEvent('hskweb_mock_tests_click')
        this.$router.push('/chooselevel')
      } else if (key === 'feedback') {
        analytics.logEvent('hskweb_contactus_click')
        this.$router.push('/feedback')
      } else if (key === 'blog_and_faq') {
        const lang = this.$i18n.locale;
        window.location.href = lang === 'zh'
          ? `/cn/index.html`
          : `/en/index.html`;
      } else if (key === 'agreement') {
        analytics.logEvent('hskweb_termsofuse_click')
        window.open(
          `${this.$store.state.publicUrl.mockPublicUrl}/static/mock_mobile_web/policy/china/en/mock_user_policy.html`
        )
        // window.open(
        //   this.isChina
        //     ? `${this.$store.state.publicUrl.mockPublicUrl}/static/mock_mobile_web/policy/china/en/mock_user_policy.html`
        //     : `${"https://mock-public.wohui.co"}/static/mock_mobile_web/policy/china/en/user_terms.html`,
        // );
      } else if (key === 'privacy') {
        analytics.logEvent('hskweb_privacypolicy_click')
        window.open(
          `${this.$store.state.publicUrl.mockPublicUrl}/static/mock_mobile_web/policy/china/en/mock_privacy_policy.html`
        )
        // window.open(
        //   this.isChina
        //     ? `${this.$store.state.publicUrl.mockPublicUrl}/static/mock_mobile_web/policy/china/en/mock_privacy_policy.html`
        //     : `${"https://mock-public.wohui.co"}/static/mock_mobile_web/policy/china/en/privacy_policy.html`,
        // );
      } else if (key === 'android') {
        //安卓下载埋点
        analytics.logEvent('hskweb_android_click', mixpanelParams)
        window.open(
          this.isChina
            ? process.env.VUE_APP_MODE == 'prod'
              ? `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest.china-mockChina-prod.apk`
              : `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest.china-mockChina-test.apk`
            : process.env.VUE_APP_MODE == 'prod'
            ? `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest-foreign-prod.apk`
            : `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest-foreign-test.apk`
        )
      } else if (key === 'app-store') {
        //苹果下载埋点
        analytics.logEvent('hskweb_apple_click', mixpanelParams)
        window.open(
          this.isChina
            ? 'https://apps.apple.com/cn/app/hsk-mock-china/id6453362725'
            : 'https://apps.apple.com/cn/app/hsk-mock/id1624661903'
        )
      } else if (key === 'pricing') {
        this.$router.push({
          name: 'priceForm',
        })
      } else if (key === 'google-play') {
        //谷歌下载埋点
        analytics.logEvent('hskweb_google_click', mixpanelParams)
        window.open('https://play.google.com/store/apps/details?id=com.wohui.mocktest')
      }
    },
    jumpWoHui() {
      //wohui点击埋点
      let mixpanelParams = { people_id: this.peopleId, unlimited: this.unlimited }
      analytics.logEvent('hskweb_teachlearn_click', mixpanelParams)
      window.open('https://wohuimandarin.com')
    },
    // pc三方埋点事件
    trackEvent(trackEvent) {
      analytics.logEvent(trackEvent)
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #2c2f46;
  &-pc {
    .footer-nav {
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    .footer-nav-content {
      width: 1200px;
      margin: 0 auto;
      padding: 43px 0 20px;
      .content-top,
      .content-bottom {
        display: flex;
        justify-content: space-between;
        align-items: start;
        &.content-bottom {
          margin-top: 20px;
        }
        &-left {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: start;
          row-gap: 20px;
          font-family: Calibri;

          & > img {
            height: 30px;
            margin-left: 12px;
          }

          ol {
            display: flex;
            li {
              margin-left: 12px;
              width: 38px;
              height: 38px;
              border-radius: 50%;
              overflow: hidden;
              cursor: pointer;
              transition: transform 0.3s ease-in-out;
              &:hover {
                transform: scale(1.1);
              }
            }
          }

          .text {
            color: rgba(255, 255, 255, 0.8);
            padding-left: 12px;
            font-size: 16px;
            line-height: 25px;
          }

          &.content-bottom-left {
            margin-top: 8px;
          }
        }
        &-right {
          padding-top: 20px;
          padding-right: 50px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          row-gap: 16px;
          column-gap: 32px;
        }
      }

      .download-item {
        width: 82px;
        height: 24px;
        margin-left: 12px;
        background-repeat: no-repeat;
        background-size: cover;
        &.android {
          background-image: url('@/assets/images/footer/Android.png');
          &:hover {
            background-image: url('@/assets/images/footer/Android_hover.png');
          }
        }
        &.app-store {
          background-image: url('@/assets/images/footer/Apple.png');
          &:hover {
            background-image: url('@/assets/images/footer/Apple_hover.png');
          }
        }
        &.google-play {
          background-image: url('@/assets/images/footer/Google.png');
          &:hover {
            background-image: url('@/assets/images/footer/Google_hover.png');
          }
        }
      }
    }
    .copyright-wrap {
      padding: 15px;
      .copyright {
        text-align: center;
        color: #fafafb;
        font-family: Calibri;
        font-size: 12px;
      }
    }
  }
}
.link {
  color: #b5b5be;
  font-family: Calibri;
  font-size: 16px;
  &:hover {
    color: #fff;
  }
}
.vertical-line {
  display: inline-block;
  width: 1px;
  height: 20px;
  opacity: 0.4;
  background: #b5b5be;
  margin: 0 15px;
}
// 移动端适配
.footer-mobile {
  padding: 14px 26px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 12px;
  .footer-nav-content {
    width: 100%;
    padding: 43px 0 20px;
    .content-top,
    .content-bottom {
      display: flex;
      justify-content: space-between;
      align-items: start;
      flex-direction: column;

      &.content-bottom {
        margin-top: 20px;
      }
      &-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        row-gap: 20px;

        & > img {
          height: 30px;
          margin-left: 12px;
        }

        ol {
          display: flex;
          li {
            margin-left: 12px;
            width: 38px;
            height: 38px;
            border-radius: 50%;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.3s ease-in-out;
            &:hover {
              transform: scale(1.1);
            }
          }
        }

        .text {
          color: rgba(255, 255, 255, 0.8);
          padding-left: 12px;
          font-size: 16px;
          line-height: 25px;
        }

        &.content-bottom-left {
          margin-top: 8px;
        }
      }
      &-right {
        padding-left: 12px;
        padding-top: 40px;
        padding-right: 50px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 16px;
        column-gap: 32px;
      }
    }

    .download-item {
      width: 82px;
      height: 24px;
      margin-left: 12px;
      background-repeat: no-repeat;
      background-size: cover;
      &.android {
        background-image: url('@/assets/images/footer/Android.png');
        &:hover {
          background-image: url('@/assets/images/footer/Android_hover.png');
        }
      }
      &.app-store {
        background-image: url('@/assets/images/footer/Apple.png');
        &:hover {
          background-image: url('@/assets/images/footer/Apple_hover.png');
        }
      }
      &.google-play {
        background-image: url('@/assets/images/footer/Google.png');
        &:hover {
          background-image: url('@/assets/images/footer/Google_hover.png');
        }
      }
    }
  }
  .download {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    .download-item {
      width: 102px;
      height: 30px;
      background-repeat: no-repeat;
      background-size: cover;
      &.android {
        background-image: url('@/assets/images/footer/Android.png');
      }
      &.app-store {
        background-image: url('@/assets/images/footer/Apple.png');
      }
      &.google-play {
        background-image: url('@/assets/images/footer/Google.png');
      }
    }
  }
  .copyright {
    width: 77.948vw;
    font-family: 'Calibri';
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #b5b5be;
    margin: 15px auto 0;
  }
  .china-text {
    font-size: 14px;
  }
}
// @media screen and (max-width: 768px) {
//    .footer-content {
//     width: auto;
//     display: flex;
//     flex-direction: column;

//    }
// }
</style>
